import option from 'assets/icons/settings.png'
import exit from 'assets/icons/logout.png'

import styles from './ProfileTopBar.module.scss'

const ProfileTopBar = ({ user, userId, onOpenOptions, onExit }) => {
  if (user.surName === 'NewTech' || userId !== undefined) return null
  return (
    <>
      <div className={styles.profile_header}>
        <img src={option} onClick={onOpenOptions} alt="" />
      </div>
      <div className={styles.profile_exit}>
        <img src={exit} onClick={onExit} alt="" />
      </div>
    </>
  )
}

export default ProfileTopBar
